/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




function changeClass()
 
    {
      
 
        document.getElementById("size-guide-outer").className = "size-guide-outer is-active is-visible";
 
    }

function removeClass()
 
    {
      var element = document.getElementById("size-guide-outer");
        element.classList.remove("is-active");
 
   
 
    }

$('.product_scarfs_slider').slick({
	slidesToShow: 4,
	dots: false,
  	infinite: true,
	arrows: true,
	prevArrow: '<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
	nextArrow: '<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg></button>',
	adaptiveHeight: true,
	slidesToScroll: 1,
	autoplay: false
});

$('.product_scarfs_drawer').slick({
  slidesToShow: 2,
  dots: false,
  infinite: true,
  arrows: true,
  prevArrow: '<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
  nextArrow: '<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg></button>',
  slidesToScroll: 1,
  autoplay: false,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
});

$('.open_sizeguide').on('click', function(){
  if($('#size_guide_drawer').hasClass('active_guide')) {
    return false;
  } else {
    $('#size_guide_drawer').addClass('active_guide');
    $(this).addClass('active_guide_click');
    $('.open_fitguide').removeClass('active_guide_click');
    $('#fit_guide_drawer').removeClass('active_guide');
  }
});

$('.open_fitguide').on('click', function(){
  if($('#fit_guide_drawer').hasClass('active_guide')) {
    return false;
  } else {
    $('#fit_guide_drawer').addClass('active_guide');
    $(this).addClass('active_guide_click');
    $('.open_sizeguide').removeClass('active_guide_click');
    $('#size_guide_drawer').removeClass('active_guide');
  }
});


